// Префикс /filter нужен для того, чтобы отличить модалы от шторок на втором уровне навигации

import { Gender, Period, Constitution } from 'common-constants/api6.types'

// Как модалы будут выпилены, можно этот префикс убрать.
export const searchSettingsInterestsPath = '/filter/tags'
export const searchSettingsGeoSelectPath = '/filter/geo-select'
export const searchSettingsPurposePath = '/filter/purpose'
export const searchSettingChildrenPath = '/filter/children'
export const searchSettingsEducationPath = '/filter/education'
export const searchSettingsPhysiquePath = '/filter/physique'
export const searchSettingsOrientationPath = '/filter/orientation'
export const searchSettingsSignPath = '/filter/sign'
export const searchSettingsAppearancePath = '/filter/appearance'
export const searchSettingsLanguagePath = '/filter/language'
export const searchSettingsAlcoholPath = '/filter/alcohol'
export const searchSettingsSmokePath = '/filter/smoke'
export const searchSettingsWithPhotoPath = '/filter/with-photo'
export const searchSettingsNoveltyPath = '/filter/novelty'
export const searchSettingsAccommodationPath = '/filter/accommodation'
export const searchSettingsMoneyPath = '/filter/money'

export const defaultSearchForm = {
  myGender: 'ANY' as Gender,
  interests: [] as number[],
  lookFor: '' as Gender,
  ageFrom: null as null | number,
  ageTo: null as null | number,
  country: null,
  region: null,
  city: null,
  metro: null,
  target: [] as string[],
  sign: [] as string[],
  whoAreNear: null as null | boolean,
  withPhoto: null,
  withCompatibleSign: null,
  periodType: '' as string,
  period: '' as Period,
  replyRate: null,
  children: [] as string[],
  weightFrom: null,
  weightTo: null,
  weightUnit: '' as string,
  heightFrom: null,
  heightTo: null,
  heightUnit: '' as string,
  education: [] as string[],
  constitution: [] as Constitution[],
  orientation: [] as string[],
  race: [] as string[],
  lang: [] as string[],
  smoke: [] as string[],
  drink: [] as string[],
  circumstance: [] as string[],
  home: [] as string[],
  limit: null,
  offset: null,
  navChanged: null,
  navOid: null,
  navActive: null,
  isExtended: null,
  isRestored: null,
  location: '' as string,
  requestSearchSource: null,
  currentLocation: {},
} as const

export type DefaultSearchForm = typeof defaultSearchForm
